import instance from '../utils/axios';

export const fetchFancyExposure = async (event_id) => {
    return await instance.get(`/api/betting/fancy-exposure/${event_id}`);
};